/**
 * MFA Passkey Step
 *
 * The passkey answer to a second factor (ECOSYSTEM-EMAIL-001 Q-EE-34 P5; owner ruling Q-EE-37, "Yes, a passkey
 * counts"): one action that starts the browser's passkey ceremony. There is no code to type, so it takes the place of
 * the code field; the host's `onVerifyPasskey` runs the ceremony and the verify, and its failure arrives through the
 * same `error` prop a refused code does.
 *
 * @module @puffin-core/mfa-ui/internal/MfaPasskeyStep
 */

import PropTypes from 'prop-types';

/**
 * @param {Object} props
 * @param {() => void} props.onVerifyPasskey - starts the ceremony (the host awaits it)
 * @param {boolean} props.isLoading - whether a ceremony or its verify is in progress
 * @param {string} [props.errorId] - the error element's id, for `aria-describedby`
 * @param {Function} props.t - translation function
 * @returns {React.JSX.Element}
 */
export function MfaPasskeyStep({ onVerifyPasskey, isLoading, errorId, t }) {
  return (
    <div className="mfa-passkey-step" data-testid="mfa-passkey-step">
      <button
        type="button"
        className="btn btn-primary"
        onClick={onVerifyPasskey}
        disabled={isLoading}
        aria-describedby={errorId}
        data-testid="mfa-passkey-btn"
      >
        {isLoading ? t('btn_verifying') : t('btn_use_passkey')}
      </button>
    </div>
  );
}

MfaPasskeyStep.propTypes = {
  onVerifyPasskey: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  errorId: PropTypes.string,
  t: PropTypes.func.isRequired,
};
